module.exports = __webpack_public_path__ + "static/media/steps_icon1.d547c444.svg";